
/*
 * Hale & Ellery
 * Mobile Quick Add visibility
 */

document.addEventListener('click', function (event) {

  if (window.innerWidth >= 750) return;

  const target = event.target;

  if (!(target instanceof Element)) return;

  /* Do not interfere with the Add to Cart button */

  if (target.closest('.hale-wide-quick-add')) {
    return;
  }

  /* Find the selected product */

  const selectedCard = target.closest('product-card');

  /* Hide the button on all other products */

  document.querySelectorAll(
    'product-card.quick-add-active'
  ).forEach(function (card) {

    card.classList.remove('quick-add-active');

  });

  /* Show the button on the selected product */

  if (selectedCard) {

    selectedCard.classList.add('quick-add-active');

  }

});